import { forwardRef, useId } from 'react';
import { Form } from 'react-aria-components/Form';
import { Button, Input, Label, SearchField } from 'react-aria-components/SearchField';
import { VisuallyHidden } from 'react-aria-components/VisuallyHidden';

import { SearchBarTranslation } from '../../../../app/localization/SiteTranslation';
import Icon from '../../../../app/shared/components/Icon/Icon';
import css from './SearchBar.css';

const SEARCH_FIELD_NAME = 'search';

interface SearchBarProps extends Pick<React.ComponentPropsWithoutRef<'search'>, 'className' | 'style'> {
  translation: SearchBarTranslation;
  onSearch: (query: string) => void;
  autoFocus?: boolean;
}

const SearchBar = forwardRef<HTMLElement, SearchBarProps>(({ autoFocus, onSearch, translation, ...props }, ref) => {
  const id = useId();

  function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();

    const formData = new FormData(event.target as HTMLFormElement);
    const query = formData.get(SEARCH_FIELD_NAME) as string;

    onSearch(query);
  }

  return (
    <search ref={ref} id={id} {...props}>
      <Form className={css.form} onSubmit={handleSubmit}>
        <SearchField className={css.field} name={SEARCH_FIELD_NAME}>
          <VisuallyHidden elementType={Label}>{translation.label}</VisuallyHidden>
          <Input className={css.input} placeholder={translation.placeholder} autoComplete="off" autoFocus={autoFocus} />
          <Button className={css.buttonClear} aria-label={translation.clearButton}>
            <Icon className={css.icon} name="cross" />
          </Button>
        </SearchField>
        <Button type="submit" className={css.buttonSubmit} aria-label={translation.submitButton}>
          <Icon className={css.icon} name="search" />
        </Button>
      </Form>
    </search>
  );
});

export default SearchBar;
